import HomePage from './HomePage'
import EmployeesPage from './EmployeesPage'
import EmployeeDetailsPage from './EmployeeDetailsPage'
import CostCenterPage from './CostCenterPage'
import CostCenterDetailsPage from './CostCenterDetailsPage'
import ProjectsPage from './ProjectsPage'
import ProjectDetailsPage from './ProjectDetailsPage'
import CompanyPage from './CompanyPage.json'
import CompanyDetailsPage from './CompanyDetailsPage.json'
import ReportsPage from './ReportsPage.json'
import FinancialPage from './FinancialPage.json'
import LoginPage from './LoginPage.json'
import AccessProfilesPage from './AccessProfilesPage'
import WebCallPage from './WebCallPage'
import NewWebCallPage from './NewWebCallPage'
import UsagePoliciesPage from './UsagePoliciesPage'
import ResetPassword from './ResetPassword'
import ReceiptsPage from './ReceiptsPage'
import CreditPoliciesPage from './CreditPoliciesPage'
import EmployeePage from './EmployeePage'
import Welcome from './Welcome'
import Wizard from './Wizard'
import ConsolidatedReportsPage from './ConsolidatedReportsPage'
import SearchPhonePage from './SearchPhonePage'
import ConsolidatedReportPage from './ConsolidatedReportPage'
import UsersPage from './UsersPage'
import UserPage from './UserPage'
import TokenRequestPage from './TokenRequestPage'
import ManualRetrieval from './ManualRetrieval'
import FinancialAdjustmentsPage from './FinancialAdjustmentsPage'
import RideCreditPage from './RideCreditPage'
import ImportNfePage from './ImportNfePage'
import RevenuesPage from './RevenuesPage'
import EmployeeMassCreditPolicyPage from './EmployeeMassCreditPolicyPage'
import BuyRideCouponPage from './BuyRideCouponPage'
import CompanyFinancialConfigPage from './CompanyFinancialConfigPage'
import UsagePolicyPage from './UsagePolicyPage'
import InvoiceExtendDueDate from './InvoiceExtendDueDate'
import FirstAccessPage from './FirstAccessPage'
import CompanyGroupPage from './CompanyGroupPage'
import CompanyDataPage from './CompanyDataPage'
import BulkImportPage from './BulkImportPage'
import ExpiredLinkPage from './ExpiredLinkPage'
import PaymentStatusPage from './PaymentStatusPage'
import InvoiceExtendDueDateSoldOutRequests from './InvoiceExtendDueDateSoldOutRequests'
import IncentivesPage from './IncentivesPage'
import SAPConcurIntegrationPage from './SAPConcurIntegrationPage'

export default {
  HomePage,
  EmployeesPage,
  EmployeeDetailsPage,
  CostCenterPage,
  CostCenterDetailsPage,
  ProjectsPage,
  ProjectDetailsPage,
  CompanyPage,
  CompanyDetailsPage,
  ReportsPage,
  FinancialPage,
  LoginPage,
  AccessProfilesPage,
  WebCallPage,
  NewWebCallPage,
  UsagePoliciesPage,
  ResetPassword,
  ReceiptsPage,
  CreditPoliciesPage,
  EmployeePage,
  Welcome,
  Wizard,
  ConsolidatedReportsPage,
  SearchPhonePage,
  ManualRetrieval,
  FinancialAdjustmentsPage,
  RideCreditPage,
  ImportNfePage,
  UsersPage,
  UserPage,
  TokenRequestPage,
  ConsolidatedReportPage,
  RevenuesPage,
  EmployeeMassCreditPolicyPage,
  CompanyFinancialConfigPage,
  BuyRideCouponPage,
  UsagePolicyPage,
  InvoiceExtendDueDate,
  FirstAccessPage,
  CompanyGroupPage,
  CompanyDataPage,
  BulkImportPage,
  ExpiredLinkPage,
  PaymentStatusPage,
  InvoiceExtendDueDateSoldOutRequests,
  IncentivesPage,
  SAPConcurIntegrationPage
}
